/*
  Merqelo product page (sections/mq-product.liquid). The option pickers are plain radio
  buttons; this script matches the chosen values to a variant and updates the price, the
  selected-value labels, the photo gallery (that variant's photos, then the shared photos),
  the design link and the ?variant= URL. Without JavaScript the page still shows the
  selected variant's photos.
*/
(() => {
  const root = document.querySelector('[data-mq-pdp]');
  const dataEl = root && root.querySelector('[data-mq-pdp-data]');
  if (!dataEl) return;

  const data = JSON.parse(dataEl.textContent);
  const mainImage = root.querySelector('.mq-pdp__image');
  const thumbs = root.querySelector('[data-mq-thumbs]');
  const price = root.querySelector('[data-mq-price]');
  const design = root.querySelector('[data-mq-design]');

  const checkedValues = () => {
    const values = [];
    root.querySelectorAll('[data-mq-option]:checked').forEach((input) => {
      values[Number(input.dataset.mqOption)] = input.value;
    });
    return values;
  };

  const matches = (variant, values) => variant.options.every((value, i) => values[i] === undefined || value === values[i]);

  const check = (index, value) => {
    root.querySelectorAll(`[data-mq-option="${index}"]`).forEach((input) => {
      input.checked = input.value === value;
    });
  };

  const showImage = (src, alt) => {
    if (!mainImage || !src) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = src;
    if (alt !== undefined) mainImage.alt = alt;
    root.querySelectorAll('[data-mq-thumb]').forEach((thumb) => {
      if (thumb.dataset.mqThumb === src) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  };

  const renderThumbs = (photos) => {
    if (!thumbs) return;
    thumbs.replaceChildren(
      ...photos.map((photo) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mq-pdp__thumb';
        button.dataset.mqThumb = photo.src;
        const img = document.createElement('img');
        img.src = photo.thumb;
        img.alt = '';
        img.loading = 'lazy';
        const label = document.createElement('span');
        label.className = 'mq-visually-hidden';
        label.textContent = photo.alt || '';
        button.append(img, label);
        item.append(button);
        return item;
      })
    );
    thumbs.hidden = photos.length < 2;
  };

  const update = (changed) => {
    let values = checkedValues();
    let variant = data.variants.find((v) => matches(v, values));

    // A combination that does not exist: keep the option just changed, take the first variant with it.
    if (!variant && changed) {
      const index = Number(changed.dataset.mqOption);
      variant = data.variants.find((v) => v.options[index] === changed.value);
      if (!variant) return;
      variant.options.forEach((value, i) => check(i, value));
      values = variant.options;
    }
    if (!variant) return;

    root.querySelectorAll('[data-mq-selected]').forEach((label) => {
      label.textContent = values[Number(label.dataset.mqSelected)] || '';
    });
    if (price) price.textContent = variant.price;

    const photos = variant.photos.concat(data.shared || []);
    if (photos.length) {
      renderThumbs(photos);
      showImage(photos[0].src, photos[0].alt);
    }
    if (design) design.href = design.dataset.mqDesign.replace('[variant]', variant.id);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState(window.history.state, '', url);
  };

  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-mq-option]')) update(event.target);
  });

  root.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-mq-thumb]');
    if (thumb) showImage(thumb.dataset.mqThumb, thumb.querySelector('.mq-visually-hidden')?.textContent);
  });
})();
